import { useState } from "react";
import { Radio, SlidersHorizontal } from "lucide-react";
import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { LiveChoices } from "@/components/LiveChoices";

// Permanent entry point at the top of Feed: pick which Middle Live issues update your feed without leaving it.
export const LiveFeedPicker = ({ following, onClose }) => {
  const [open, setOpen] = useState(false);
  const close = (v) => { if (!v) { setOpen(false); onClose(); } };
  return (
    <>
      <button onClick={() => setOpen(true)} className="surface flex w-full items-center gap-3 px-4 py-3 text-left transition-colors hover:border-emerald-300" data-testid="feed-live-picker-btn">
        <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-emerald-50 text-[hsl(var(--facts))]"><Radio size={17} /></span>
        <span className="min-w-0 flex-1"><span className="block text-sm font-medium">Choose which Middle Live categories appear in your feed</span>
          <span className="block text-xs text-slate-500" data-testid="feed-live-picker-btn-sub">{following ? `${following} chosen` : "None chosen yet"}</span></span>
        <SlidersHorizontal size={16} className="shrink-0 text-slate-400" />
      </button>
      <Sheet open={open} onOpenChange={close}>
        <SheetContent side="bottom" className="max-h-[85vh] overflow-y-auto rounded-t-2xl sm:mx-auto sm:max-w-xl" data-testid="feed-live-picker-sheet">
          <SheetHeader className="text-left"><SheetTitle className="font-serif text-2xl font-medium">Middle Live in your Feed</SheetTitle><SheetDescription className="sr-only">Turn items on or off for Feed</SheetDescription></SheetHeader>
          <div className="mt-3"><LiveChoices bare /></div>
        </SheetContent>
      </Sheet>
    </>
  );
};
